import {queryOptions} from '@tanstack/react-query';
import {fetchBillingSubscription} from './fetchBillingSubscription';

export const billingSubscriptionQuery = queryOptions({
  queryFn: fetchBillingSubscription,
  queryKey: ['billing', 'subscription'],
});
